<template>
    <div id="app">
        <SignInPC v-if="isPC" />
        <SignInH5 v-else />
    </div>
</template>
<script>
import SignInPC from '../components/SignInPC';
import SignInH5 from '../components/SignInH5';
import loadScript from '../../../uitl/load-script';

export default {
    components: {
        SignInPC,
        SignInH5
    },
    data() {
        return {};
    },
    mounted() {
        // loadScript('https://hm.baidu.com/hm.js?0ce553680a3f0cc475b7603c90b3f1ea');
        // loadScript('https://tb.53kf.com/code/code/90d3e270b5d355aa44bafe74fd7fe8a11/2"');
        loadScript('https://hm.baidu.com/hm.js?001e5e9e10d733aa5b4d4d8dfcd24687');
        var _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/90d3e270b5d355aa44bafe74fd7fe8a11/2";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
    }
};
</script>
<style>
    body {
        -webkit-overflow-scrolling: touch;
    }
    #app {
        height: 100%;
    }
    #mobile_minchat_div {
        display: none!important;
    }
</style>
